import { render, staticRenderFns } from "./OpeningFormComponent.vue?vue&type=template&id=b6de6ba0&xmlns=true&"
import script from "./OpeningFormComponent.vue?vue&type=script&lang=js&"
export * from "./OpeningFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports